import { Fragment, useState } from "react";
import { Users } from "react-feather";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Btn } from "../../../../../../AbstractElements";
import AddContactForm from "./AddContactForm";

const AddContact = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Fragment>
      <Btn color="primary" className="button-primary btn-block btn-mail w-100" onClick={toggle}><Users />{"New Contacts"}</Btn>
      <Modal modalClassName="modal-bookmark" isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{"Add Contact"}</ModalHeader>
        <ModalBody>
          <AddContactForm setModal={setModal} toggle={toggle} />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};
export default AddContact;
